import * as Yup from 'yup'

const panRegex = /^([A-Z]{5})(\d{4})([A-Z]{1})$/
export const createAgreementValidationSchema = Yup.object({
  property_uuid: Yup.string().required('Property is required'),
  agreement_type: Yup.string().required('Agreement type is required'),
  document_signing_template_uuid: Yup.string().when('agreement_type', (val, schema) => {
    if (val === 'create') return Yup.string().required('Template is required')
    else return Yup.string().notRequired()
  }),
  file_data: Yup.string().when('agreement_type', (val, schema) => {
    if (val === 'upload') return Yup.string().required('Agreement upload is required')
    else return Yup.string().notRequired()
  }),
  signers: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('Name is required.'),
      identifier: Yup.string().when('identifier_type', (val, schema) => {
        if (val === 'email')
          return Yup.string().required('Email address is required').email('Wrong email format')
        else
          return Yup.string()
            .required('Phone number is required.')
            .matches(/^\+\d{2} \d{5}-\d{5}$/, 'Please use the format "+91 99999-99999"')
      }),
      sign_type: Yup.string().required('Sign type is required.'),
      reason: Yup.string().required('Reason is required.'),
    })
  ),
  witness: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('Name is required.'),
      identifier: Yup.string().when('identifier_type', (val, schema) => {
        if (val === 'email')
          return Yup.string().required('Email address is required').email('Wrong email format')
        else
          return Yup.string()
            .required('Phone number is required.')
            .matches(/^\+\d{2} \d{5}-\d{5}$/, 'Please use the format "+91 99999-99999"')
      }),
      sign_type: Yup.string().required('Sign type is required.'),
      reason: Yup.string().required('Reason is required.'),
    })
  ),
  sign_on_page: Yup.string().required('Type of signing pages is required'),
  is_estamp: Yup.string().required('Type of signing pages is required'),
  estamp_amount: Yup.string().when('is_estamp', (val, schema) => {
    if (val === 'true')
      return Yup.number()
        .typeError('eStamp amount must be a number')
        .integer('eStamp amount must be an integer')
        .positive('eStamp amount must be a positive number')
        .min(1, 'eStamp amount must be at least 1')
        .max(99999, 'eStamp amount cannot be more than 99999')
        .required('eStamp amount is required')
    else return Yup.string().notRequired()
  }),
  estamp_state: Yup.string().when('is_estamp', (val, schema) => {
    if (val === 'true') return Yup.string().required('Province/State is required')
    else return Yup.string().notRequired()
  }),

  lessor_courtesy_titles: Yup.string().required('Required'),
  lessor_full_name: Yup.string()
    .max(50, 'Maximum 50 characters are allowed')
    .required('Full name is required'),
  lessor_age: Yup.number()
    .typeError('Age must be a number')
    .integer('Age must be an integer')
    .positive('Age must be a positive number')
    .min(1, 'Age must be at least 1')
    .max(99999, 'Age cannot be more than 99999')
    .required('Age is required'),
  lessor_address_1: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('Address is required'),
  lessor_address_2: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('Address is required'),
  // .optional(),
  lessor_address_city: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('City is required'),
  lessor_address_state: Yup.string().required('Province/State is required'),
  lessor_address_pincode: Yup.number()
    .typeError('Pincode must be a number')
    .positive('Pincode must be a positive number')
    .integer('Pincode must be an integer')
    .min(100000, 'Pincode must be at least 6 digits')
    .max(999999, 'Pincode cannot be more than 6 digits')
    .required('Pincode is required'),
  lessor_pan: Yup.string().matches(panRegex, 'Invalid PAN format').required('PAN is required'),
  lessee_courtesy_titles: Yup.string().required('Required'),
  lessee_full_name: Yup.string()
    .max(50, 'Maximum 50 characters are allowed')
    .required('Full name is required'),
  lessee_age: Yup.number()
    .typeError('Age must be a number')
    .integer('Age must be an integer')
    .positive('Age must be a positive number')
    .min(1, 'Age must be at least 1')
    .max(99999, 'Age cannot be more than 99999')
    .required('Age is required'),
  lessee_address_1: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('Address is required'),
  lessee_address_2: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('Address is required'),
  // .optional(),
  lessee_address_city: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('City is required'),
  lessee_address_state: Yup.string().required('Province/State is required'),
  lessee_address_pincode: Yup.number()
    .typeError('Pincode must be a number')
    .positive('Pincode must be a positive number')
    .integer('Pincode must be an integer')
    .min(100000, 'Pincode must be at least 6 digits')
    .max(999999, 'Pincode cannot be more than 6 digits')
    .required('Pincode is required'),
  lessee_pan: Yup.string().matches(panRegex, 'Invalid PAN format').required('PAN is required'),
  lessee_mobiles: Yup.string()
    .required('Phone number is required.')
    .matches(/^\+\d{2} \d{5}-\d{5}$/, 'Please use the format "+91 99999-99999"'),
  lessee_email_id: Yup.string().required('Email address is required').email('Wrong email format'),
  lessee_aadhar: Yup.string()
    .matches(/^\d{12}$/, 'Aadhar number must be 12 digits')
    .required('Aadhar number is required'),
  property_address_1: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('Address is required'),
  property_address_2: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('Address is required'),
  // .optional(),
  property_address_city: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('City is required'),
  property_address_state: Yup.string().required('Province/State is required'),
  property_address_pincode: Yup.number()
    .typeError('Pincode must be a number')
    .positive('Pincode must be a positive number')
    .integer('Pincode must be an integer')
    .min(100000, 'Pincode must be at least 6 digits')
    .max(999999, 'Pincode cannot be more than 6 digits')
    .required('Pincode is required'),
  property_rent_day: Yup.number()
    .typeError('Rent day must be a number')
    .positive('Rent day must be a positive number')
    .integer('Rent day must be an integer')
    .required('Rent day is required'),
  property_rent_monthly_amount: Yup.number()
    .typeError('Rent amount must be a number')
    .positive('Rent amount must be a positive number')
    .integer('Rent amount must be an integer')
    .required('Rent amount is required'),
  property_rent_monthly_amount_words: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(500, 'Maximum 500 characters are allowed')
    .required('Enter the rent amount in words'),
  property_advance_amount: Yup.number()
    .typeError('Advance amount must be a number')
    .positive('Advance amount must be a positive number')
    .integer('Advance amount must be an integer')
    .required('Advance amount is required'),
  property_advance_amount_words: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(500, 'Maximum 500 characters are allowed')
    .required('Enter the advance amount in words'),
  account_holder_courtesy_titles: Yup.string().required('Required'),
  account_holder_name: Yup.string()
    .max(50, 'Maximum 50 characters are allowed')
    .required('Account holder name is required'),
  account_holder_pan: Yup.string()
    .matches(panRegex, 'Invalid PAN format')
    .required('PAN is required'),
  account_number: Yup.string()
    .matches(/^[a-zA-Z0-9]*$/, 'Only alphanumeric characters')
    .max(30, 'Maximum 30 characters are allowed')
    .required('Account number is required'),
  account_bank_name: Yup.string().required('Bank name is required'),
  account_bank_branch_name: Yup.string().required('Branch name is required'),
  account_bank_ifsc: Yup.string()
    .matches(/^[a-zA-Z0-9]*$/, 'Only alphanumeric characters')
    .max(30, 'Maximum 30 characters are allowed')
    .required('IFSC number is required'),
  rent_agreement_start_date: Yup.string().required('Start date is required'),
  rent_agreement_end_date: Yup.string().required('End date is required'),
  witness1_address_1: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .optional(),
  witness1_address_2: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .optional(),
  witness1_address_city: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .optional(),
  witness1_address_state: Yup.string().optional(),
  witness1_address_pincode: Yup.number()
    .typeError('Pincode must be a number')
    .positive('Pincode must be a positive number')
    .integer('Pincode must be an integer')
    .min(100000, 'Pincode must be at least 6 digits')
    .max(999999, 'Pincode cannot be more than 6 digits')
    .optional(),
  witness2_address_1: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .optional(),
  witness2_address_2: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .optional(),
  witness2_address_city: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .optional(),
  witness2_address_state: Yup.string().optional(),
  witness2_address_pincode: Yup.number()
    .typeError('Pincode must be a number')
    .positive('Pincode must be a positive number')
    .integer('Pincode must be an integer')
    .min(100000, 'Pincode must be at least 6 digits')
    .max(999999, 'Pincode cannot be more than 6 digits')
    .optional(),
  property_short_description: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(1000, 'Maximum 1000 characters are allowed')
    .required('Property description is required'),
  agreement_generated_date: Yup.string().required('Agreement generated date is required'),
  agreement_generated_city: Yup.string().required('Agreement generated city is required'),
  agreement_jurisdiction_city: Yup.string().required('Agreement jurisdiction city is required'),
  furnished_room_details: Yup.array().of(
    Yup.object().shape({
      room_name: Yup.string()
        .min(3, 'Minimun 3 characters required')
        .max(50, 'Maximum 50 characters are allowed')
        .required('Room name is required'),
      room_details: Yup.string()
        .min(3, 'Minimun 3 characters required')
        .max(250, 'Maximum 250 characters are allowed')
        .required('Furniture detail is required'),
    })
  ),
})
